function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5.69,
  d: "M31.42 64V15.21"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.85 23H49L31.42 0 13.85 23z",
  fill: "currentColor"
});

function SvgArrowLineUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI1LjY5IiBkPSJNMzEuNDIgNjRWMTUuMjEiLz4KICA8cGF0aCBkPSJNMTMuODUgMjNINDlMMzEuNDIgMCAxMy44NSAyM3oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";
export { SvgArrowLineUp as ReactComponent };